
import { react_api } from "../../config";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";



let toast;
let axiosInstance;
let translator;
// Funzione di inizializzazione per configurare le variabili
const initSurveyService = (translation, t, axiosInst) => {

    
  translator = translation;
  toast = t;
  axiosInstance = axiosInst;
};

const  createSurveyADP = async (body, onCompleteToast) => {
  
    try {


     
      
      const options =   {
        
        headers: {
          'Content-Type': 'application/json',
          "Authorization": sessionStorage.getItem("token")
        },
       
      }
    
     
      const urlFetch = `${react_api}/survey/createSurveyADP`;
      const response = await axiosInstance.post(urlFetch,body, options);
      console.info("response: ", response);
      const result =  response.data;
      console.info("result: ", result);
      if (result.status == HTTP_STATUS_CODES.OK ){
       

        toast({
            title:  translator('toastMsg.surveyHttpService.surveyCreatedSuccessful'),
            
            position: "top",
            status: 'info',
            duration: 1500,
            isClosable: true,

            onCloseComplete: onCompleteToast
          
          });
       
    
      }
    } catch (error) {
      toast({
        title:  translator('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true});
    }

}

const  saveSurveyDraftADP = async (body , onCompleteToast) => {
  
    try {


     
      
      const options =   {
        
        headers: {
          'Content-Type': 'application/json',
          "Authorization": sessionStorage.getItem("token")
        },
       
      }
    
     
      const urlFetch = `${react_api}/survey/saveSurveyDraftADP`;
      const response = await axiosInstance.post(urlFetch,body, options);
      console.info("response: ", response);
      const result =  response.data;
      console.info("result: ", result);
      if (result.status == HTTP_STATUS_CODES.OK ){
       

        toast({
          title: body.id_survey_info == null ? translator('toastMsg.surveyHttpService.surveyDraftSavedSuccessful'):translator('toastMsg.surveyHttpService.surveyDraftUpdatedSuccessful') ,
          
          position: "top",
          status: 'info',
          duration: 1500,
          isClosable: true,
          onCloseComplete: onCompleteToast
        
        });
     

  
  }
    } catch (error) {
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true});
    }

}




const  receiveAnswerADP = async (body) => {
  
    try {


     
      
      const options =   {
        
        headers: {
          'Content-Type': 'application/json',
          "Authorization": sessionStorage.getItem("token")
        },
       
      }
    
     
      const urlFetch = `${react_api}/survey/receiveAnswerADP`;
      const response = await axiosInstance.post(urlFetch,body, options);
      console.info("response: ", response);
      const result =  response.data;
      console.info("result: ", result);
      if (result.status == HTTP_STATUS_CODES.OK ){
       

       return result
       

  
  }
    } catch (error) {
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true});
    }

}


const  getSurveyADP = async (body ) => {
  
    try {


     
      
      const options =   {
        
        headers: {
          'Content-Type': 'application/json',
          "Authorization": sessionStorage.getItem("token")
        },
       
      }
    
     
      const urlFetch = `${react_api}/survey/getSurveyADP`;
      const response = await axiosInstance.post(urlFetch,body, options);
      console.info("response: ", response);
      const result =  response.data;
      console.info("result: ", result);
      if (result.status == HTTP_STATUS_CODES.OK ){
       

        return result
       

  
  }
    } catch (error) {
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true});
    }





  

}






const  getSurveyStructureByHash = async (hash ) => {
    console.log(hash)
  try {

    const params = {
      hash: hash, // Aggiungi qui i parametri che desideri
    };
   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
      params: params, // Agg
     
    }
  
   
    const urlFetch = `${react_api}/survey/getSurveyStructureByHash`;
    const response = await axiosInstance.get(urlFetch, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
     

      return result
     


}
  } catch (error) {
    console.log(error)
   toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }







}





const  openSurveyADP = async (body ) => {
  
    try {


     
      
      const options =   {
        
        headers: {
          'Content-Type': 'application/json',
          "Authorization": sessionStorage.getItem("token")
        },
       
      }
    
     
      const urlFetch = `${react_api}/survey/openSurveyADP`;
      const response = await axiosInstance.post(urlFetch,body, options);
      console.info("response: ", response);
      const result =  response.data;
      console.info("result: ", result);
      if (result.status == HTTP_STATUS_CODES.OK ){
       

        console.log(response)
       

  
  }
    } catch (error) {
      toast({
        title:  translator('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true});
    }



    


}

const  getSurveyCatalogueADP = async (  body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/getSurveyCatalogueADP`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}


const  getExpertsADP = async (  body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/getExpertsADP`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch, body,options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}



const  createExpertsGroupADP = async (  body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/createExpertsGroupADP`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}

const  getExpertsGroupsADP = async (  owner) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
      params: { owner }
     
    }
  
   
    const urlFetch = `${react_api}/survey/getExpertsGroupsADP`;
    console.log(urlFetch)
    const response = await axiosInstance.get(urlFetch, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
    toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}


const  getExpertsInGroupADP = async (  body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/getExpertsInGroupADP`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch, body.groupId,options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
    toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}

const  createExpertADP = async ( t, body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/createExpertADP`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status.toString() == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}

const  updateExpertADP = async ( t, body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/updateExpertADP`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status.toString() == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}



const  createExpertsGroupCsvADP = async (t, formData) => {

  console.log(axiosInstance)
  try {



    console.log()
   
    
    
      const options = {
        headers: {
         
          "Authorization": sessionStorage.getItem("token"),
        },
      };
  
  
   
    const urlFetch = `${react_api}/survey/createExpertsGroupCsvADP`;
    
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch,formData, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}


const deleteExpertsGroupADP = async (t, groupId) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/deleteExpertsGroupADP/${groupId}`;
    console.log("Deleting group with ID:", groupId);

    // Chiamata DELETE all'endpoint
    const response = await axiosInstance.delete(urlFetch, options);
    console.info("response: ", response);

    // Controllo del risultato della risposta
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};


const deleteExpertADP = async (t, expertId) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/deleteExpertADP/${expertId}`;
    console.log("Deleting expert with ID:", expertId);

    // Chiamata DELETE all'endpoint
    const response = await axiosInstance.delete(urlFetch, options);
    console.info("response: ", response);

    // Controllo del risultato della risposta
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};

const updateExpertsGroupADP = async (t, groupId, updateData) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
        "Content-Type": "application/json", // Header per il body JSON
      },
    };

    // URL dell'endpoint per l'aggiornamento
    const urlFetch = `${react_api}/survey/updateExpertsGroupADP/${groupId}`;
    console.log("Updating group with ID:", groupId);
    console.log("Update data:", updateData);

    // Chiamata PUT all'endpoint con i dati aggiornati
    const response = await axiosInstance.put(urlFetch, updateData, options);
    console.info("response: ", response);

    // Controllo del risultato della risposta
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};


const cloneExpertGroupADP = async (t, body) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
        "Content-Type": "application/json", // Header per il body JSON
      },
    };

    // URL dell'endpoint per l'aggiornamento
    const urlFetch = `${react_api}/survey/cloneExpertGroupADP`;
   

    // Chiamata PUT all'endpoint con i dati aggiornati
    const response = await axiosInstance.post(urlFetch, body, options);
    console.info("response: ", response);

    // Controllo del risultato della risposta
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK) {
      return result;
    }else {
      throw Error(result.message)
      
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });

    
  }
};


const cloneSurveyADP = async (t, body) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
         "Content-Type": "application/json"
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/cloneSurveyADP`;
  

   
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);

   
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};



const getSurveyAnswerStatusADP = async (t, surveyId) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token"),
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/getSurveyAnswerStatus/${surveyId}`;
   

    // Chiamata DELETE all'endpoint
    const response = await axiosInstance.get(urlFetch, options);
    console.info("response: ", response);

    // Controllo del risultato della risposta
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};


const getStatisticChartsADP = async (t, surveyId) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token"),
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/getStatisticChartsADP`;
   

    // Chiamata DELETE all'endpoint
    const response = await axiosInstance.post(urlFetch, surveyId,options);
    console.info("response: ", response);

    // Controllo del risultato della risposta
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};

const createSurveyConsensus = async (t, body) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
         "Content-Type": "application/json"
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/createSurveyConsensusADP`;
  

   
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);

   
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};


const updateSurveyConsensus = async (t, body) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
         "Content-Type": "application/json"
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/updateSurveyConsensusADP`;
  

   
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);

   
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};



const openSurveyConsensus = async (t, body) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
         "Content-Type": "application/json"
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/openSurveyConsensusADP`;
  

   
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);

   
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};


const receiveConsensusAnswerADP = async (t, body) => {
  try {
    // Configurazione dell'header con il token di autorizzazione
    const options = {
      headers: {
        "Authorization": sessionStorage.getItem("token"),
         "Content-Type": "application/json"
      },
    };

    // URL dell'endpoint per l'eliminazione
    const urlFetch = `${react_api}/survey/receiveConsensusAnswerADP`;
  

   
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);

   
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.OK || result.status === HTTP_STATUS_CODES.NOT_FOUND ) {
      return result;
    }
  } catch (error) {
    console.warn(error);
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};


const  createEmailMessage = async ( t, body) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/createEmailMessage`;
    console.log(urlFetch)
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status.toString() == HTTP_STATUS_CODES.OK ){
      

      return result
     


}
  } catch (error) {
      console.warn(error)
  toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }






}


const  getEmailMessage = async (t,body ) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/survey/getEmailMessages`;
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
     

      return result
     


}
  } catch (error) {
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }







}

const  insertValidationMetadataMl = async (t,body ) => {
  
  try {


   
    
    const options =   {
      
      headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem("token")
      },
     
    }
  
   
    const urlFetch = `${react_api}/stagingAreaResult/insertValidationMetadataMl`;
    const response = await axiosInstance.post(urlFetch,body, options);
    console.info("response: ", response);
    const result =  response.data;
    console.info("result: ", result);
    if (result.status == HTTP_STATUS_CODES.OK ){
     

      return result
     


}
  } catch (error) {
    console.log(error)
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true});
  }







}




const  getValidationMetadataMl = async (id ) => {
  
try {


  
  const options =   {
    
    headers: {
      'Content-Type': 'application/json',
      "Authorization": sessionStorage.getItem("token")
    }
  
   
  }

 
  const urlFetch = `${react_api}/getValidationMetadataMl/${id}`;
  const response = await axiosInstance.get(urlFetch, options);
  console.info("response: ", response);
  const result =  response.data;
  console.info("result: ", result);
  if (result.status == HTTP_STATUS_CODES.OK ){
   

    return result
   


}
} catch (error) {
  console.log(error)
 toast({
    title: translator('toastMsg.callError'),
    description: String(error),
    position: "top",
    status: 'warning',
    duration: 4000,
    isClosable: true});
}







}

export {initSurveyService ,createSurveyADP,saveSurveyDraftADP,receiveAnswerADP,getSurveyADP,getSurveyStructureByHash,cloneSurveyADP,openSurveyADP,getSurveyCatalogueADP,getExpertsADP,createExpertsGroupADP,getExpertsGroupsADP,getExpertsInGroupADP,createExpertADP,updateExpertADP,createExpertsGroupCsvADP , updateExpertsGroupADP, deleteExpertsGroupADP,cloneExpertGroupADP,deleteExpertADP,getSurveyAnswerStatusADP,createSurveyConsensus,updateSurveyConsensus,openSurveyConsensus,receiveConsensusAnswerADP,createEmailMessage,getEmailMessage,insertValidationMetadataMl,getValidationMetadataMl,getStatisticChartsADP}
